var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "images" },
        _vm._l(_vm.image_paths, function(path, type) {
          return _c("div", { key: type, staticClass: "image-group" }, [
            Object.keys(_vm.image_paths).length > 1
              ? _c("span", { staticClass: "image-type" }, [
                  _vm._v(_vm._s(_vm.docType(type)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.image_paths[type] != undefined && _vm.image_paths[type] != ""
              ? _c("label", { staticClass: "image" }, [
                  _c("input", {
                    staticClass: "hidden",
                    attrs: {
                      type: "file",
                      id: type + "_" + path,
                      accept: ".jpg, .jpeg, .png"
                    },
                    on: {
                      change: function($event) {
                        return _vm.changePath($event, type)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: _vm.image_paths[type], width: _vm.size }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "overlay" })
                ])
              : _c("div", { staticClass: "container" }, [
                  _c(
                    "form",
                    {
                      attrs: { enctype: "multipart/form-data", novalidate: "" }
                    },
                    [
                      _c("div", { staticClass: "dropbox" }, [
                        _c("input", {
                          staticClass: "input-file",
                          attrs: {
                            type: "file",
                            disabled: _vm.preloader,
                            id: type + "_" + path,
                            accept: ".jpg, .jpeg, .png"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changePath($event, type)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.preloader
                          ? _c("p", [
                              _vm._v(
                                "\n              Fazendo upload da foto...\n            "
                              )
                            ])
                          : _c("p", [
                              _vm._v("\n              Arraste a foto aqui"),
                              _c("br"),
                              _vm._v(
                                "\n              ou clique para escolher\n            "
                              )
                            ])
                      ])
                    ]
                  )
                ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("v-slider", {
        staticClass: "align-self-stretch",
        attrs: { min: "300", max: "400", step: "1" },
        model: {
          value: _vm.size,
          callback: function($$v) {
            _vm.size = $$v
          },
          expression: "size"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4ec3f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4ec3f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Documents/DocumentPath.vue
// module id = null
// module chunks = 